import React from 'react';
import {observer} from 'mobx-react';
import {ObjectSelect2, FormLayout, FormError} from 'components';
import {withState, t} from 'shared/core';
import {Spinner} from 'components';
import {AddRevieweeState} from '../state';
import {ModalButtons} from 'components/modals';

const LoadingState = observer(({isOpen}) => {
  return (
    <div className='height-400'>
      <Spinner/>
    </div>
  );
});


const SelectReviewee = observer(({uiState}) => {
  return (
    <ObjectSelect2
      label='performance_reviews.manage.Reviewee'
      items={uiState.revieweeEmployees}
      value={uiState.selectedReviewee}
      onChange={reviewee => uiState.updateReviewee(reviewee)}
      placeholder='performance_reviews.manage.Add participant'
      searchable
      allowClear
    />
  );
});

const SelectManager = observer(({uiState}) => {
  if (!uiState.selectedReviewee) return null;
  
  return (
    <ObjectSelect2
      label='performance_reviews.manage.Manager reviewer'
      helpLink={{
        title: t('components.help_link.Who is this?'),
        explanation: {
          header: 'performance_reviews.manage.MANAGER_HELP_HEADER',
          paragraphs: [
            t('performance_reviews.manage.MANAGER_HELP_DESC_1'),
            t('performance_reviews.manage.MANAGER_HELP_DESC_2'),
            t('performance_reviews.manage.MANAGER_HELP_DESC_3')
          ]
        }
      }}
      items={uiState.employees}
      value={uiState.selectedManager}
      onChange={manager => uiState.updateManagerReviewer(manager)}
      searchable
      allowClear
    />
  );
});

const SelectPeers = observer(({uiState}) => {
  if (!uiState.showPeerSelector || !uiState.selectedReviewee) return null;

  return (
    <ObjectSelect2
      label='performance_reviews.manage.Peer reviewers'
      items={uiState.employees}
      value={uiState.selectedPeers}
      onAdd={peer => uiState.addPeer(peer)}
      onRemove={peer => uiState.removePeer(peer)}
      placeholder='performance_reviews.manage.Add peer'
      multiple
    />
  );
});

const AddReviewee = observer(({uiState}) => {
  const {errors} = uiState;
  return (
    <div>
      <FormLayout>
        <SelectReviewee uiState={uiState}/>
        <SelectManager uiState={uiState}/>
        <SelectPeers uiState={uiState}/>
        <FormError message={errors.base}/>
      </FormLayout>
      <ModalButtons onCancel={uiState.onHide} onSave={() => uiState.saveReviewee()}/>
    </div>
  );
});

export default withState(
  AddReviewee,
  AddRevieweeState,
  {
    spinner: LoadingState
  }
);
